import {
  ArpMedia,
  ArpMediaType,
  FeaturedArpMedia,
  PaginatedResponse,
  PaginationParams,
  QueryParams
} from '@arpeggi/shared'
import { useAuth } from '../../hooks/useAuth'
import axios from '../../lib/axios'

export type Parts = Array<keyof Pick<ArpMedia, 'subComponents'>>

export interface GetFeaturedMediaParams extends PaginationParams<FeaturedArpMedia> {
  type?: ArpMediaType[]
  [QueryParams.PARTS]?: Parts
}

export const getOneFeaturedMedia = async (arpMediaId: number) => {
  const { data } = await axios.get<FeaturedArpMedia>(`/api/v2/featured-media/${arpMediaId}`)

  return data
}

export const useFeaturedMediaAPI = () => {
  const { authenticatedPost, authenticatedDelete } = useAuth()

  const getFeaturedMedia = async (params?: GetFeaturedMediaParams) => {
    const { data } = await axios.get<PaginatedResponse<FeaturedArpMedia>>(
      '/api/v2/featured-media',
      { params }
    )

    return data
  }

  const createFeaturedMedia = async (arpMediaId: number) => {
    const { data } = await authenticatedPost<FeaturedArpMedia>('/api/v2/featured-media', {
      arpMediaId
    })

    return data
  }

  const deleteFeaturedMedia = async (arpMediaId: number) => {
    return authenticatedDelete(`/api/v2/featured-media/${arpMediaId}`)
  }

  return { getFeaturedMedia, createFeaturedMedia, deleteFeaturedMedia }
}
